import { render, staticRenderFns } from "./ConfigMain.vue?vue&type=template&id=221337aa&scoped=true"
import script from "./ConfigMain.vue?vue&type=script&lang=js"
export * from "./ConfigMain.vue?vue&type=script&lang=js"
import style0 from "./ConfigMain.vue?vue&type=style&index=0&id=221337aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221337aa",
  null
  
)

export default component.exports